import axios from '../http-common';

const createAxiosRequest = (token) => {
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	return {
		get: (url, params = {}) => axios.get(url, { ...config, ...params }),
		post: (url, data) => axios.post(url, data, config),
		put: (url, data) => axios.put(url, data, config),
		delete: (url) => axios.delete(url, config),
	};
};

const axiosWithToken = createAxiosRequest;
const getAdminsList = (page, token, search, company) => {
	return axiosWithToken(token).get(
		`/super-admin/list-admin?page=${page}&search=${search}&company=${company || ''}`,
	);
};

const getClaimsList = (token, page) => {
	return axiosWithToken(token).get(`/super-admin/claim/?page=${page}`);
};

const createAdmin = (token, data) => {
	return axiosWithToken(token).post('/super-admin/list-admin/create', data);
};

const blockAdmin = (token, id, data) => {
	return axiosWithToken(token).post(`/super-admin/list-admin/blocked/${id}`, data);
};

const updateAdmin = (token, id, data) => {
	return axiosWithToken(token).put(`/super-admin/list-admin/${id}`, data);
};

const searchAdmin = (token, name) => {
	return axiosWithToken(token).post(`/super-admin/list-admin/search?search=${name}`);
};

const getClients = (token, page, search, type, company) => {
	let url = `/super-admin/clients/SuperAdmin?page=${page || 1}&limit=10`;
	if (search) url += `&search=${search}`;
	if (type) url += `&type=${type}`;
	if (company) url += `&company=${company}`;
	return axiosWithToken(token).get(url);
};

const getParrainageList = (token, page, beneficiaryCompany, sponsorCompany) => {
	let url = `/super-admin/parrainage/list?page=${page || 1}&limit=6`;
	if (beneficiaryCompany) url += `&beneficiaryCompany=${beneficiaryCompany}`;
	if (sponsorCompany) url += `&sponsorCompany=${sponsorCompany}`;
	return axiosWithToken(token).get(url);
};

const toggleParrainageStatus = (token, id) => {
	let url = `/super-admin/parrainage/toggle-status/${id}`;
	return axiosWithToken(token).put(url);
};

const searchClaim = (token, value, page, status) => {
	return axiosWithToken(token).get(`/super-admin/claim`, {
		params: { search: value, page: page, status: status },
	});
};

const createCompany = (token, data) => {
	return axiosWithToken(token).post(`/super-admin/companies`, data);
};

const updateCompany = (token, id, data) => {
	return axiosWithToken(token).put(`/super-admin/companies/${id}`, data);
};

const deleteCompany = (token, id) => {
	return axiosWithToken(token).delete(`/super-admin/companies/${id}`);
};

const getCompaniesList = (page, token, search) => {
	return axiosWithToken(token).get(`/super-admin/companies?page=${page}&search=${search}`);
};

const getCompaniesForAdmins = (token) => {
	return axiosWithToken(token).get(`/super-admin/companies/admins`);
};

const getAllFinancementsSA = (token, page, status, company, search) => {
	let url = `/super-admin/financements?page=${page || 1}&limit=10`;
	if (status) url += `&status=${status}`;
	if (company) url += `&company=${company}`;
	if (search) url += `&search=${search}`;
	return axiosWithToken(token).get(url);
};
const getFinancementDetailsSA = (token, id) => {
	return axiosWithToken(token).get(`/super-admin/financement/${id}`);
};
const updateFinancementSA = (token, id, data) => {
	return axiosWithToken(token).put(`/super-admin/financement/update/${id}`, data);
};
const deleteFinancementSA = (token, id) => {
	return axiosWithToken(token).delete(`/super-admin/financement/delete/${id}`);
};
// ─── Contenaire Services ─────────────────────────────────────────────────────
const createContenaire = (token, data) => {
	return axiosWithToken(token).post('/super-admin/contenaires', data);
};

const getContenairesList = (token, page = 1, search = '') => {
	let url = `/super-admin/contenaires?page=${page}&limit=10`;
	if (search) url += `&search=${search}`;
	return axiosWithToken(token).get(url);
};

const getAllContenairesList = (token) => {
	return axiosWithToken(token).get('/super-admin/contenaires/all');
};

const getContenaireById = (token, id) => {
	return axiosWithToken(token).get(`/super-admin/contenaires/${id}`);
};

const updateContenaire = (token, id, data) => {
	return axiosWithToken(token).put(`/super-admin/contenaires/${id}`, data);
};

const deleteContenaire = (token, id) => {
	return axiosWithToken(token).delete(`/super-admin/contenaires/${id}`);
};

const deleteMultipleContenaires = (token, ids) => {
	return axiosWithToken(token).post('/super-admin/contenaires/delete-multiple', { ids });
};

const SuperAdminServices = {
	getAdminsList,
	getAllFinancementsSA,
	createAdmin,
	blockAdmin,
	getFinancementDetailsSA,
	updateAdmin,
	deleteFinancementSA,
	updateFinancementSA,
	searchAdmin,
	getClaimsList,
	searchClaim,
	createCompany,
	updateCompany,
	deleteCompany,
	toggleParrainageStatus,
	getCompaniesList,
	getCompaniesForAdmins,
	getClients,
	getParrainageList,
	createContenaire,
	getContenairesList,
	getAllContenairesList,
	getContenaireById,
	updateContenaire,
	deleteContenaire,
	deleteMultipleContenaires,
};
export default SuperAdminServices;
